module.exports = __webpack_public_path__ + "img/historia2.d2bc53d9.jpg";